import { Icons } from '@agro-club/agroclub-shared'
import useFormatDate from 'hooks/useFormatDate'
import { refetchFunc } from 'modules/domain/common/hooks'
import { User } from 'modules/domain/user/types'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import PermissionCheck from 'views/components/PermissionCheck/PermissionCheck'
import { Verified, VerifiedDate } from '../../styled'
import { SecurityConfirmModal } from './ConfirmModals/SecurityConfirmModal'

type Props = {
  userRefetch: refetchFunc
  user: User
}

export const VerifiedBySecurity = ({ user, userRefetch }: Props) => {
  const { t } = useTranslation('user')
  const formatDate = useFormatDate()
  const [verifySecurityModal, setVerifySecurityModal] = useState(false)

  if (!user.profile) return null

  return (
    <>
      <PermissionCheck scope={['users.can_verify_as_security']}>
        <div>
          <Verified isVerified={user.profile.is_verified_by_security} onClick={() => setVerifySecurityModal(true)}>
            <div>
              <Icons.IconDefend />
              <span>
                {t('verified')}
                <br />
                {t('is_verified_by_security')}
              </span>
            </div>
          </Verified>
          {user.profile.verified_by_security_at && (
            <VerifiedDate>{formatDate(user.profile.verified_by_security_at)}</VerifiedDate>
          )}
        </div>
      </PermissionCheck>

      {verifySecurityModal && (
        <SecurityConfirmModal onClose={() => setVerifySecurityModal(false)} refetch={userRefetch} userId={user.id} />
      )}
    </>
  )
}
